<template lang="pug">
  div.table-wrapper
    v-layout.row.align-center
      v-flex.offset-xs10.xs2
        v-text-field.mr-3(
          v-if="searchBar"
          :value="search",
          append-icon="search",
          :label="$t('search.search')"
          @change="research"
        )
      slot(name="searchBar")
    v-layout.justify-space-between.align-center.pr-3.pb-3.pt-3(v-if="showPagination" :class="{ 'offset-xs4': !deleteAction }")
      div.pl-4(style="min-height: 20px;")
        v-layout.align-center(v-if="!loading")
          slot(name="resultCount")
            v-layout.justify-end.title.pr-3 {{ formatNum(totalItems) }} résultat{{ totalItems !== 1 ? 's' : '' }}
          slot(name="appendResultCount")
      v-pagination(
        v-if="totalItems > pagination.rowsPerPage"
        :length="pageCount"
        v-model="pagination.page"
        @input="recallApi"
        totalVisible="8"
      )
      div(v-else style="height: 42.38px;")
    v-data-table(
      item-key="id"
      v-model="selected"
      hide-actions
      :items="items"
      :pagination.sync="pagination"
      :rows-per-page-items="pagination.rowsPerPageItems"
      :total-items="pagination.totalItems"
      :headers-length="filteredHeaders.length"
      :rows-per-page-text='$t("data_table.rows_per_page")'
      :totalItems="totalItems"
      :select-all="displayFilters"
    )
      template(slot="no-data")
        tr
          td.text-xs-center(:colspan="filteredHeaders.length" v-if="!loading") Aucun résultat.
      template(slot="no-results")
        tr
          td.text-xs-center(:colspan="filteredHeaders.length" v-if="!loading") Aucun résultat.
      template(slot="headers" slot-scope="props")
        th.pt-2.pb-2(v-for="header in filteredHeaders" :width="header.width || '100%'" :class="header.type === 'id' ? 'hidden' : ''")
          rc-table-header.pb-2.d-flex(
            v-bind="header"
            :displayFilters="displayFilters"
            :all="props.all"
            :bdColumn="header.filters && header.filters.column ? header.filters.column : header.column"
            :indeterminate="props.indeterminate"
            :pagination="pagination"
            :translateHeaders="translateHeaders"
            :filterValues="header.filters ? header.filters.values : null"
            :displaySortable="displaySortable"
            :metadata="metadata"
            :prevValues="filters"
            ref="headerCell"
            @filterUpdate="updateFilters"
            @editBodyParams="editBodyParams"
            @changeSort="changeSort"
            @toggleAll="toggleAll"
            @get="recallApi"
            v-if="!(header.type === 'actions' && header.buttons.length === 0)"
          )
      template(slot="items" slot-scope="props" v-if="loading === false")
        rc-table-row(
          :item="props.item"
          :headers="filteredHeaders"
          :selected="props.selected"
          :loading="loading"
          :clickToVisit="clickToVisit"
          @toggleSelected="() => props.selected = !props.selected"
          @sendEmit="sendEmit"
        )
    slot(name="footer")
    v-layout(v-if="loading" style="height: 500px" v-rc-loader="true")
    v-layout.align-center.row.py-2.sticky-footer.white(v-if="deleteAction || (showPagination && totalItems > pagination.rowsPerPage)" :class="deleteAction ? 'justify-space-between' : 'justify-end'")
      v-dialog(v-model="dialog" persistent max-width="450" v-if="!loading && deleteAction")
        v-btn.error(slot="activator") SUPPRIMER
        v-card
          v-card-title(class="headline") Confirmer la suppression.
          v-card-text Cette opération ne pourra pas être annulée.
          v-card-actions
            v-spacer
            v-btn(color="grey" dark depressed @click.native="dialog = false") Annuler
            v-btn(
              color="error" depressed @click.native="dialog = false"
              @click="deleteSelection") Confirmer
      v-pagination.mr-4(
        v-if="!loading && showPagination && totalItems > pagination.rowsPerPage"
        :length="pageCount"
        v-model="pagination.page"
        @input="recallApi"
        totalVisible="8"
      )
</template>

<script>
import RcTableHeader from '@/components/RcTable/RcTableHeader.vue';
import RcTableRow from '@/components/RcTable/RcTableRow.vue';
import cloneDeep from 'lodash/cloneDeep';

export default {
  name: 'RcTable',
  i18nOptions: { namespaces: ['commons'] },
  components: {
    RcTableHeader,
    RcTableRow,
  },
  props: {
    selectedItems: {
      type: Object,
      default: () => {},
    },
    totalItems: {
      type: Number,
      default: 0,
    },
    headers: {
      default: () => [],
      type: Array,
    },
    items: {
      default: () => [],
      type: Array,
    },
    searchBar: {
      default: false,
      type: Boolean,
    },
    showPagination: {
      default: true,
      type: Boolean,
    },
    deleteAction: {
      default: true,
      type: Boolean,
    },
    loading: {
      type: Boolean,
      default: true,
    },
    translateHeaders: {
      type: Boolean,
      default: false,
    },
    displayFilters: {
      type: Boolean,
      default: true,
    },
    displaySortable: {
      type: Boolean,
      default: true,
    },
    searchField: {
      type: String,
      default: null,
    },
    initialParams: {
      type: Object,
      default: () => {},
    },
    metadata: {
      type: Object,
      default: () => {},
    },
    clickToVisit: {
      type: Boolean,
      default: true,
    },
    maxItems: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      dialog: false,
      selected: [],
      filters: [],
      pagination: {
        descending: true,
        page: 1,
        rowsPerPage: 100,
        sortBy: '',
        totalItems: 0,
        rowsPerPageItems: [10, 20, 50, 100],
      },
      search: '',
      extraParams: {
        ...this.initialParams
      },
    };
  },
  methods: {
    formatNum(n) {
      return new Intl.NumberFormat('fr-FR').format(n);
    },
    research(value) {
      if (this.search !== value) {
        this.search = value;
        this.recallApi();
      }
    },
    sendEmit(data) {
      this.$emit('sendEmit', data);
      this.$emit(data.emitName, data.value);
    },
    toggleAll(indeterminate) {
      if (this.selected.length && indeterminate === false) {
        this.selected = [];
      } else {
        this.selected = this.items.slice();
      }
    },
    editBodyParams(value, param, paramValue) {
      this.pagination.page = 1;
      if (value) {
        this.extraParams[param] = paramValue;
      } else {
        delete this.extraParams[param];
      }
    },
    updateFilters(column, filter) {
      this.pagination.page = 1;
      if (this.filters.findIndex(item => item.field === column) !== -1) {
        this.filters.splice(this.filters.findIndex(item => item.column === column));
      }
      if (filter.value) {
        this.filters.push({
          field: column,
          entity: filter.entity,
          operand: filter.operand,
          value: filter.value !== null ? filter.value : '',
        });
      }
      this.recallApi();
    },
    recallApi() {
      const params = { ...this.extraParams };
      params.start = (this.pagination.page - 1) * this.pagination.rowsPerPage;
      params.size = this.pagination.rowsPerPage;
      params.filters = cloneDeep(this.filters);
      if (this.search && this.search.length) {
        params.filters.push({
          field: this.searchField || 'name',
          operand: 'ilike',
          value: this.search,
        });
      }
      params.orders = cloneDeep([
        {
          field: this.pagination.sortBy !== '' ? this.pagination.sortBy : this.filteredHeaders[0].column,
          ascending: this.pagination.descending,
        },
      ]);
      params.orders = params.orders.filter(it => it.field !== 'id');
      this.$emit('recall', params);
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
        this.recallApi();
      } else {
        this.pagination.descending = true;
        this.pagination.sortBy = column;
        this.recallApi();
      }
    },
    deleteSelection() {
      this.$emit('deleteSelection', this.selected, this.size);
    },
  },
  computed: {
    pageCount() {
      if (this.totalItems === 0) {
        return 0;
      }
      if (this.maxItems && (this.maxItems / this.pagination.rowsPerPage) < (this.totalItems / this.pagination.rowsPerPage)) {
        return this.maxItems / this.pagination.rowsPerPage;
      }
      if (this.totalItems % this.pagination.rowsPerPage === 0) {
        return this.totalItems / this.pagination.rowsPerPage;
      }
      return Math.floor(this.totalItems / this.pagination.rowsPerPage) + 1;
    },
    filteredHeaders() {
      return this.headers.filter(header => !header.adminOnly || this.$store.state.app.destination.id == 1)
    },
  },
  mounted() {
    this.$emit(
      'mounted',
      this.pagination.rowsPerPage,
      (this.pagination.page - 1) * this.pagination.rowsPerPage,
    );
    const firstSearchBar = this.$refs.headerCell.find(x => !!x.$refs.text);
    if (firstSearchBar) {
      firstSearchBar.$refs.text.focus();
    }
  },
};
</script>
<style lang="scss">
  .sticky-footer {
    position: sticky;
    bottom: 0;
    width: 100%;
    z-index: 2;
  }
  .table-wrapper {
    height: 100%;
    width: 100%;
    table.v-table thead tr {
      height: 48px;
    }
  }
  th.hidden {
    display: none;
  }
  table {
    table-layout: fixed;
  }
  tbody {
    tr:nth-child(odd) {
      background-color: #eee;
    }
    tr:hover {
      background-color: #ddd !important;
    }
  }
  button:focus {
    outline: 0;
  }
</style>
